import type { FeeGridScopeTypes } from '@generated/graphql';
import type { Organization } from './organization';

export enum FeeTierStates {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export type FeeGrid = {
  minMarketValueCents?: number;
  annualFeeBps?: number;
  annualFeeCents?: number;
};

export type FeeTier = {
  id?: string;
  name?: string;
  default?: boolean;
  grid?: FeeGrid[];
  gridScopeType?: FeeGridScopeTypes;
  blendedGrid?: boolean;
  flatAnnualFeeBps?: number;
  discountPercentage?: number;
  state?: FeeTierStates;
  requestId?: string;
  chargeForCash?: boolean;
  chargeForCashOnHold?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  organization?: Organization;
  billableAUM?: boolean;
};
